export default __webpack_public_path__ + "static/media/single-project-page-01-img13.19017e4f.jpg";